
import { computed, ref, watch } from 'vue'
import { cancelUploadResource } from '@/utils/nativeFn';
export default {
    name: 'UploadProgress',
    props: {
        total: {
            type: Number,
            default: 0
        },
        doneNum: {
            type: Number,
            default: 0
        },
        failNum: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        },
        uploadErrorFlag: {
            type: Boolean,
            default: false
        },
    },
    emits: ['cancelUpload'],
    setup(props, { emit }) {
        const total = computed(() => props.total)
        const doneNum = computed(() => props.doneNum)
        const failNum = computed(() => props.failNum)
        const uploadErrorFlag = computed(() => props.uploadErrorFlag)
        watch([doneNum, failNum], ([doneNumVal, failNumVal]) => {
            if (props.visible) {
                if (failNum.value > 0 && doneNum.value + failNum.value >= total.value) {
                    uploadErrorFlag.value ? emit('cancelUpload') : emit('cancelUpload', 'fail')
                } else if (doneNum.value >= total.value) {
                    // 上传完成 操作取消
                    uploadErrorFlag.value ? emit('cancelUpload') : emit('cancelUpload', 'done')
                }
            }
        })
        const cancelUpload = () => {
            cancelUploadResource()
            emit('cancelUpload')
        }
        const visible = computed(() => props.visible)
        const numPercent = computed(() => (props.total ? props.doneNum * 100 / props.total : 0) > 100 ? 100 : (props.total ? props.doneNum * 100 / props.total : 0) )
        const renderRightRate = (rate: number) => {
            if (rate < 50) {
                return 'transform: rotate(' + 3.6 * rate + 'deg);';
            } else {
                return 'transform: rotate(0);border-color: #269AFF;';
            }
        };
        const renderLeftRate = (rate: number) => {
            if (rate >= 50 && rate < 100) {
                return 'transform: rotate(' + 3.6 * (rate - 50) + 'deg);';
            }
            if (rate >= 100) {
                return 'transform: rotate(' + 3.6 * (rate - 50) + 'deg);border-color: #269AFF;';
            }
        };
        const rightStyle = computed(() => {
            return renderRightRate(numPercent.value)
        })
        const leftStyle = computed(() => {
            return renderLeftRate(numPercent.value)
        })
        return {
            numPercent,
            total,
            doneNum,
            visible,
            cancelUpload,
            rightStyle,
            leftStyle
        };
    },
};
